import { formatBytes } from 'utils/common';
import i18n from "shared/i18n";

const errorHandler = (errorsArray, maxSize, maxFiles = 0) => {
  const errors = [];

  errorsArray[0].errors.forEach((errorItem, index) => {
    const errorType = errorItem.code;

    switch(errorType) {
      case 'file-too-large':
        errors[index] = { code: errorType, text: i18n.t("Image size is too large. Please try another image"), maxSize: formatBytes(maxSize) };
        break;
      case 'too-many-files':
        errors[index] = { code: errorType, text: `${i18n.t("There is too many files. You could choose no more than")} ${maxFiles} ${i18n.t("files. Please try again")}`, maxSize: formatBytes(maxSize), maxFiles };
        break;
      default:
        errors[index] = { code: errorItem.code, text: errorItem.text, maxSize: formatBytes(maxSize) };
        break;
    }
  });

  return errors;
};

export default errorHandler;
